var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spark-page"},[_c('div',{staticClass:"spark-page-title"},[_vm._v(_vm._s(_vm.$options.short_name))]),_c('spark-vet-upload-public')],1)}
var staticRenderFns = []

export { render, staticRenderFns }